/**
 * The wire contract for a booking-confirmation draft payload. `RequestDraft.payload` is a Json column: the api writes
 * it and the AI Inbox reads it back, with no compiler edge between them.
 */

/** How an extracted segment lined up with the flights we quoted. */
export const SEGMENT_VERDICTS = [
  'confirms',
  'schedule-change',
  'fills-blank',
  'reroutes',
  'not-on-quote',
  'unresolved',
] as const;

export type SegmentVerdict = (typeof SEGMENT_VERDICTS)[number];

/** Why a segment could not be resolved to a comparable identity. */
export const UNRESOLVED_REASONS = ['no-flight-number', 'no-date', 'ambiguous-date', 'unparseable-date'] as const;

export type UnresolvedReason = (typeof UNRESOLVED_REASONS)[number];
